{
    "googleMapsAPIKey": "AIzaSyBb5wFapnvB4Z1lN9OA1ruUW6eQ65YebmU"
}